<template>
    <div class="content-view store-list">
        <div>
            <h2 class="fs-24 text-center fc-theme">一件包邮</h2>
            <p class="subtitle text-center fs-14 fc-666">专业礼品一件批发平台，全国顺丰、圆通、申通、邮政、丰网等仓库提供货源。</p>
            <p v-if="$store.state.phone" class="top-tip fc-333 fs-14">
                <i class="el-icon-s-opportunity"></i>
                <span>
                会员VIP<span class="fc-theme">低至1.2元起购买定制礼品</span> ，非会员VIP<span class="fc-theme">1.5元起发货</span>
                </span>
                <el-button v-if="!userData.is_vip" size="mini" type="danger" @click="$bus.emit('openVip', configData)">开通VIP</el-button>
            </p>
            <p v-else class="top-tip fc-333 fs-14">
                <i class="el-icon-s-opportunity"></i>
                <span>注册即可获得低至1.2元起购买定制礼品<span class="fc-theme point" @click="$bus.emit('openReg', configData)">点击注册</span></span>
            </p>
        </div>
        <div class="giftabs">
            <div class="text-left">
                <!-- 分类、排序 -->
                <!-- 配重专区（、高端精品、畅销专区、厨卫用品、办公用具、家具日常 -->
                <el-card shadow="never" :body-style="{ padding: '5px' }">
                    <el-form ref="form" label-width="100px" size="mini">
                        <el-form-item label="快  递：" class="flex align-center expressFromItem">
                        <el-radio-group v-model="productParam.expressSendId" @change="expressChange">
                            <template v-for="(express, index) in allExpress">
                                <el-radio :label="express.id" class="radio-item" :key="index">
                                    <template>
                                        <div class="text-center"><img :src="productParam.expressSendId == express.id ? express.express_select_url : express.express_img_url" alt="" width="30"></div>
                                        <div class="fs-12 fc-666 marginT-5">{{express.express_name}}</div>
                                    </template>
                                </el-radio>
                            </template>
                            <el-link type="danger" class="clear-all" :underline="false" @click="clearAll('expressSendId')">清空</el-link>
                        </el-radio-group>
                    </el-form-item>

                    <el-divider v-if="checkList.length > 0"></el-divider>
                    <el-form-item label="派件方式：" v-if="checkList.length > 0">
                        <el-radio-group v-model="productParam.signingMethod" @change="signingMethodChange">
                            <template v-for="sm in signingMethods">
                                <el-radio :label="sm.id" class="radio-item" :key="sm.id">
                                    <template>{{sm.name}}</template>
                                </el-radio>
                            </template>
                            <el-link type="primary" class="clear-all" :underline="false" @click="clearAll('signingMethod')">清空</el-link>
                        </el-radio-group>
                    </el-form-item>

                    <el-divider v-if="checkList.length > 0"></el-divider>
                    <el-form-item label="仓  库：" v-if="checkList.length > 0">
                        <el-radio-group v-model="productParam.warehouseId" @change="warehouseChange">
                            <template v-for="(checkType, index) in checkList">
                                <el-radio :label="checkType.custom_warehouse_id" class="radio-item" :key="index">
                                    <!-- <el-badge value="安全不降权" class="item">
                                        <span>{{checkType.expressSendName}}</span>
                                    </el-badge> -->
                                    <template>{{checkType.custom_alias_warehouse_name}}</template>
                                </el-radio>
                            </template>
                            <el-link type="danger" class="clear-all" :underline="false" @click="clearAll('warehouseId')">清空</el-link>
                        </el-radio-group>
                    </el-form-item>
                    <el-divider></el-divider>
                        <el-form-item label="排  序：" class="sortbox">
                            <el-link :underline="false" @click="toggleSort('')" :class="[isActive == '' ? 'active' : '']">综合排序</el-link>
                            <el-link
                                :underline="false"
                                v-show="priceSort == true"
                                @click="toggleSort('priceSort')"
                                :class="[isActive == 'priceSort' ? 'active' : '']"
                            >
                                价格从高到低
                                <i class="el-icon-arrow-down el-icon--right"></i>
                            </el-link>
                            <el-link
                                :underline="false"
                                v-show="priceSort == false"
                                @click="toggleSort('priceSort')"
                                :class="[isActive == 'priceSort' ? 'active' : '']"
                            >
                                价格从低到高
                                <i class="el-icon-arrow-up el-icon--right"></i>
                            </el-link>
                            <el-link
                                :underline="false"
                                v-show="weightSort == true"
                                @click="toggleSort('weightSort')"
                                :class="[isActive == 'weightSort' ? 'active' : '']"
                            >
                                重量从高到低
                                <i class="el-icon-arrow-down el-icon--right"></i>
                            </el-link>
                            <el-link
                                :underline="false"
                                v-show="weightSort == false"
                                @click="toggleSort('weightSort')"
                                :class="[isActive == 'weightSort' ? 'active' : '']"
                            >
                                重量从低到高
                                <i class="el-icon-arrow-up el-icon--right"></i>
                            </el-link>
                            <el-link
                                :underline="false"
                                v-show="countSort == true"
                                @click="toggleSort('countSort')"
                                :class="[isActive == 'countSort' ? 'active' : '']"
                            >
                                销量从高到低
                                <i class="el-icon-arrow-down el-icon--right"></i>
                            </el-link>
                            <el-link
                                :underline="false"
                                v-show="countSort == false"
                                @click="toggleSort('countSort')"
                                :class="[isActive == 'countSort' ? 'active' : '']"
                            >
                                销量从低到高
                                <i class="el-icon-arrow-up el-icon--right"></i>
                            </el-link>
                        </el-form-item>
                    </el-form>
                </el-card>

                <div id="product_loading" class="product-loading" v-show="isLoading"></div>

                <div class="goods-box" v-show="!isLoading">
                    <a v-for="(item, index) in productList" :key="index" class="news-card">
                        <good>
                            <img slot="img" :src="item.othumb" :alt="item.product_name" class="news-img" />
                            <p slot="title" class="news-title">{{ item.product_name }}</p>
                            <div slot="info">
                                <p class="fs-12 fc-666">货源地: {{item.city_code}}</p>
                                <p class="fs-12 fc-666 flex align-center">
                                    <span class="support-express">面单类型: </span>
                                    <img v-for="(item, index) in (item.user_source ? item.user_source.split(',') : [])" :key="index" class="good-info-express-img" :src="source_img[item]" width="50" alt="">
                                </p>
                                <p class="fs-12 fc-666 flex align-center"><span class="support-express">支持快递: </span><img v-if="item.express_select_url" class="good-info-express-img" :src="item.express_select_url" width="50" alt=""> <span v-else class="good-info-express-img"></span></p>
                                <p class="fs-14 fc-666">{{ item.warehouse_alias_name }}</p>
                                <p>
                                    <span v-if="!$store.state.token" class="fc-theme fs-14" style="font-size: 14px; cursor: pointer;" @click.stop="$bus.emit('openLogin')">登录后查看</span>
                                    <span v-else>
                                        ¥
                                        <!-- <span>{{ (item.site_price / 100).toFixed(2) }}</span> -->
                                        <span>{{ item.sale_price }}</span>
                                    </span>
                                    <el-tag type="info" class="news-weight" size="mini">{{ item.weight }}g/件</el-tag>
                                </p>
                                <div class="news-counts">
                                    <span class="stock">
                                        库存
                                        <b>{{ item.stock || 0 }}件</b>
                                    </span>
                                    <span class="sales">
                                        销量
                                        <b>{{ item.sales }}件</b>
                                    </span>
                                </div>
                            </div>
                        </good>
                        <div class="good-mask">
                            <!-- <span @click="addCart(item)">加入购物车</span> -->
                            <span @click="goBuy(item)">立即购买</span>
                            <span @click="viewDetail(item)">
                                查看详情
                                <!-- <router-link :to="{ path: '/store/list/details/' + item.id + '?warehouse_id=' + item.warehouse_id }">查看详情</router-link> -->
                            </span>
                        </div>
                    </a>
                </div>
                <el-pagination
                    v-if="productPage.total > productPage.pageSize"
                    @current-change="handleCurrentChange"
                    :current-page="productPage.page"
                    :page-size="productPage.pageSize"
                    layout="total, prev, pager, next, jumper"
                    :total="productPage.total"
                ></el-pagination>
            </div>
            <!-- <el-tab-pane label="历史购买" name="passBuy">
            <el-table
                :data="tableData"
                :span-method="objectSpanMethod"
                border
                style="width: 100%; margin-top: 20px"
            >
                <el-table-column prop="id" label="商品信息" width="180"></el-table-column>
                <el-table-column prop="name" label="数量"></el-table-column>
                <el-table-column prop="amount1" label="包裹总计"></el-table-column>
                <el-table-column prop="amount2" label="操作"></el-table-column>
            </el-table>
        </el-tab-pane> -->
            <!-- <router-link :to="{path:'/user/noGoods'}" class="notgoods">平台没有我想要的商品</router-link> -->
        </div>
    </div>
</template>
<script>
import good from './component/good'
import { Loading } from 'element-ui';
import { mapState } from 'vuex'
export default {
    name: 'goods',
    computed: {
        ...mapState(['userData', 'phone', 'configData'])
    },
    data() {
        return {
            isActive: '',
            isLoading: false,
            priceSort: true,
            weightSort: true,
            countSort: true,
            activeName: 'allGoods',
            allExpress: [],
            checkList: [],
            signingMethods: [
                {id: 0, name:'全部'},
                {id: 1, name:'电话派件'},
                {id: 2, name:'取件码派件'},
            ],
            productParam: {
                warehouseId: undefined,
                expressSendId: undefined,
                signingMethod: undefined,
                sort: [],
            },
            productList: [],
            productPage: {
                page: 1,
                pageSize: 40,
                total: 0,
            },
            checkType: undefined,
            // page: 1,
            tableData: [],
        }
    },
    // async created() {
    //     this.getProductList()
    // },
    methods: {
        handleCurrentChange(val) {
            this.productPage.page = val
            this.getProductList()
        },
        async getProductList() {
            this.isLoading = true
            let loadingIns = Loading.service({
                target: "#product_loading",
                text: '加载中...',
                background: 'rgba(225, 230, 235, 0.4)',
                spinner: 'el-icon-loading'
            })
            const res = await this.$fetch('/shop/webs/v1/get-product-list', { ...this.productParam, ...this.productPage, express_id: this.productParam.expressSendId, warehouse_id: this.productParam.warehouseId  }, 'post')
            this.$nextTick(() =>{
                this.isLoading = false
                loadingIns.close()
            })    
            if (res.code == 0) {
                this.productList = res.data.list
                this.productPage.total = res.data.total ? Number(res.data.total) : 0
            }
        },
        async viewDetail(item) {
            if (!localStorage.token) {
                this.$bus.emit('openLogin')
                return
            }
            const isPush = await this.needRecommendBox(item.custom_warehouse_id, item.custom_warehouse_name, item.express_id, item.express_name)
            if (!isPush) {
                this.$router.push('/store/list/details/' + item.id + '?warehouse_id=' + item.warehouse_id)
            }

        },
        async goBuy(item) {
            if (!localStorage.token) {
                this.$bus.emit('openLogin')
                return
            }
            // if (!this.needRecommendBox(item.customWarehouseId, item.expressId, item.expressName)) { // 不需要弹框
            //     this.goBuy(item);
            // }
            const isPush = await this.needRecommendBox(item.custom_warehouse_id, item.custom_warehouse_name, item.express_id, item.express_name)
            if (!isPush) {
                this.$router.push(`/store/payment?product_id=${item.id}&warehouse_id=${item.warehouse_id}`)
            }

        },
        async addCart(item) {
            const params = {
                // site_id: 1,
                product_id: item.id,
                warehouse_id: item.warehouse_id,
                numbers: 1,
            }
            const data = await this.$fetch('/vv/cart_add', params)
            if (data.status == 0) {
                this.$message.success('添加成功')
            } else {
                this.$message.error('添加失败')
            }
        },
        clearAll(type) {
            this.productParam[type] = undefined
            if (type == 'expressSendId') {
                this.checkList = []
                this.productParam.warehouseId = undefined
            }
            this.handleCurrentChange(1)
        },
        async getAllWarehouse() {
            const data = await this.$fetch( '/shop/webs/v1/get-warehouse-list', { page: 1, pageSize: 100 }, 'post' )
            if (data.code == 0) {
                this.allExpress = data.data
            }
        },
        expressChange(value) {
            if (value) {
                this.checkList = this.allExpress.find(item => item.id == value).items
            } else {
                this.checkList = []
            }
            this.productParam.warehouseId = undefined
            this.handleCurrentChange(1)
        },
        warehouseChange(val) {
            if (val) {
                this.handleCurrentChange(1)
            }
        },
        signingMethodChange(val){
            this.handleCurrentChange(1)
        },
        toggleSort(typeSort) {
            if (typeSort == 'priceSort') {
                this.priceSort = !this.priceSort
                this.getSortList('sale_price', this.priceSort)
            } else if (typeSort == 'weightSort') {
                this.weightSort = !this.weightSort
                this.getSortList('weight', this.weightSort)
            } else if (typeSort == 'countSort') {
                this.countSort = !this.countSort
                this.getSortList('sales', this.countSort)
            } else {
                this.getSortList('clear')
            }
            return (this.isActive = typeSort)
        },
        getSortList(key, sortValue) {
            if (key == 'clear') {
                this.productParam.sort = {}
                this.productPage.page = 1
                this.handleCurrentChange(1)
                return
            }
            let sort = {}
            sort[key] = sortValue ? 'desc' : 'asc'
            this.productParam.sort = { ...sort }
            this.productPage.page = 1
            this.handleCurrentChange(1)
        },
        objectSpanMethod({ row, column, rowIndex, columnIndex }) {
            if (columnIndex === 0) {
                if (rowIndex % 2 === 0) {
                    return {
                        rowspan: 2,
                        colspan: 1,
                    }
                } else {
                    return {
                        rowspan: 0,
                        colspan: 0,
                    }
                }
            }
        },
        // 判断是否需要弹框, 返回 false 表示不需要弹框, 返回含有快递id和仓库id的对象表示需要弹框, 并切换到相应的选项
        async needRecommendBox(customWarehouseId, customWarehouseName, expressId, oldExpressName) {
            return new Promise((resolve, reject) => {
                let nodeEnv = process.env.NODE_ENV;

                if(process.env.VUE_APP_APIPATH == 'test') {
                    nodeEnv = 'development'; // 如果当前的环境是测试环境, 则 env 也替换为开发环境的 env
                }
                let customWarehouseIdObj = {
                    'development': { // 开发环境对应的 不推荐仓库ID: 推荐仓库ID
                        72: 77,
                        74: 75,
                        18: 29, // 中通江苏徐州仓 -> 中通江苏苏州仓
                    },
                    'production': { // 生产环境对应的 不推荐仓库ID: 推荐仓库ID
                        8: 26, // 邮政广东梅州仓 -> 邮政广东广州仓
                        10: 5, // 顺丰湖南仓 -> 顺丰河北仓
                        7: 19, // 中通江苏徐州仓 -> 中通江苏苏州仓
                    }
                }
                let recommendBoxInfo = false;

                Object.keys(customWarehouseIdObj[nodeEnv]).forEach(item => {
                // 如果传入的仓库ID和不推荐仓库ID相同, 则做相应处理, 返回推荐快递和仓库ID
                    if (item == customWarehouseId) {
                        recommendBoxInfo = this.getWarehouseInfoByCustomWarehouseId(customWarehouseIdObj[nodeEnv][item])
                    }
                })
                // console.log({customWarehouseId, expressId, oldExpressName});
                // console.log({recommendBoxInfo});
                if (recommendBoxInfo) { // 找到推荐仓库信息
                    this.$msgbox({
                        title: '优惠提醒',
                        // message: `您选择的【${customWarehouseName}】价格较高，推荐您使用【${recommendBoxInfo.customWarehouseName}】价格更低，出单更快！`,
                        message: `当前仓库价格较高，推荐周边仓库【${recommendBoxInfo.customWarehouseName}】，价格更低，秒出单！`,
                        showCancelButton: true,
                        confirmButtonText: '立即下单',
                        cancelButtonText: '不需要',
                    }).then(action => {
                        this.productParam.expressSendId = recommendBoxInfo.expressId;
                        this.checkList = this.allExpress.find(item => item.id == recommendBoxInfo.expressId).items;
                        this.productParam.warehouseId = recommendBoxInfo.customWarehouseId;
                        this.handleCurrentChange(1)
                        resolve(true)
                    }).catch(() => {
                        resolve(false)
                    })

                } else {
                    resolve(false)
                }

            })


        },
        // 根据customWarehouseId获取仓库信息
        getWarehouseInfoByCustomWarehouseId(customWarehouseId) {
            let warehouseInfo = false
            this.allExpress.forEach(express => {
                express.items.forEach(warehouse => {
                    if (customWarehouseId == warehouse.custom_warehouse_id) {
                        warehouseInfo = {
                            expressId: warehouse.express_id,
                            expressName: express.express_name,
                            customWarehouseId: warehouse.custom_warehouse_id,
                            customWarehouseName: warehouse.custom_warehouse_name
                        }
                    }
                })
            })
            return warehouseInfo
        }
    },
    mounted() {
        if (!localStorage.compile) {
            this.getAllWarehouse()
            if (this.$route.query.express) {
                this.productParam.expressSendId = Number(this.$route.query.express)
            }
            if (this.$route.query.ware) {
                this.productParam.warehouseId = Number(this.$route.query.ware)
            }
            this.getProductList()
        }

    },
    components: { good },
    watch: {
        checkType(newValue, oldValue) {
            if (newValue == -99) {
                this.$message.error('暂未开放')
                this.checkType = oldValue
                return
            }
            this.productParam.filter.warehouse_id = newValue
            // this.getProductList()
            this.productPage.page = 1
            this.handleCurrentChange(1)
        },
    },
}
</script>
<style lang="scss" scoped>
.goods-empty {
    justify-content: center !important;
    padding: 50px;
}
.good-info-express-img {
    width: 20px !important;
    height: 20px !important;
    min-height: auto !important;
    border-radius: 4px;
    margin-right: 2px;
}
.support-express {
    font-size: 12px !important;
    color: #666 !important;
    letter-spacing: 0px !important;
}
.store-list {
    width: 1164px;
}
::v-deep {
    .expressFromItem .el-form-item__content {
        margin-left: 0px !important;
        .el-radio-group {
            display: flex;
            align-items: center;
            .radio-item {
                display: flex;
                align-items: center;
                img {
                    border-radius: 8px;
                }
            }
        }
    }
    .el-tabs__item {
        padding: 0;
        line-height: 40px;
        width: 120px;
        text-align: center;
        height: 42px;
        font-size: 18px;
        margin-right: 10px;
        color: $fcolor;
    }
    .el-tabs__active-bar {
        display: none;
    }
    .el-tabs__item.is-active {
        background-color: $bcolor;
        color: #fff;
        font-weight: bold;
    }
    .el-tabs__item:hover {
        color: $bcolor;
    }
    .el-tabs__item.is-active:hover {
        color: #fff;
    }
    .el-form-item__label {
        font-size: 12px;
        font-weight: bold;
        letter-spacing: 2px;
    }
    .el-form-item--mini.el-form-item {
        margin-bottom: 3px;
    }
    .el-divider--horizontal {
        margin: 5px 0;
    }
    .el-checkbox__label {
        font-size: 12px;
    }
    .el-form-item__content {
        .el-link {
            font-size: 12px;
        }
    }
    .el-pagination {
        text-align: center;
        margin-top: 20px;
    }
}
.el-form-item div a {
    margin-right: 20px;
    &.active {
        color: $bcolor;
    }
}
.giftabs {
    position: relative;
    padding: 20px;
}
.radio-item {
    margin-top: 4px;
}
.clear-all {
    margin-left: 40px;
    /* height: 38px; */
    position: relative;
    top: -4px;
    font-size: 14px !important;
    display: inline-block;
}

.product-loading {
    width: 100%;
    height: 200px;
}

.goods-box {
    display: -webkit-box;
    display: -ms-flexbox;
    display: flex;
    -ms-flex-wrap: wrap;
    flex-wrap: wrap;
    position: relative;
    justify-content: flex-start;
    margin-top: 20px;
    .news-card {
        margin: 5px;
        display: flex;
        flex-basis: 266px;
        flex-direction: column;
        transition: all 0.2s;
        box-sizing: border-box;
        border: 1px solid #ddd;
        text-decoration: none;
        transition: all 1s;
        position: relative;
        /* flex: 0 0 19%; */
        padding: 3px;
        .news-title {
            display: -webkit-box;
            -webkit-box-orient: vertical;
            -webkit-line-clamp: 2;
            overflow: hidden;
            margin-top: 0px;
            padding: 0 3px;
        }
        .good-simple {
            img {
                width: 100%;
                opacity: 1;
                transition: all 1s;
                position: relative;
                height: 300px;
                min-height: 300px;
            }
            div {
                border-top: none;
                flex-direction: column;
                margin: 10px 0 0 0;
                p,
                .news-counts {
                    width: 100%;
                }
                p {
                    margin: 0;
                }
                .news-counts {
                    display: flex;
                    flex-direction: row;
                    justify-content: space-between;
                    border-top: 1px solid #ddd;
                    margin-bottom: 0;
                    span {
                        font-size: 10px;
                        line-height: 35px;
                        color: rgba(0, 0, 0, 0.35);
                        font-weight: 400;
                        font-family: 苹方;
                        letter-spacing: 3px;
                        margin-right: 4px;
                        b {
                            font-weight: bold;
                            color: #cd082e;
                            letter-spacing: 0;
                        }
                    }
                }
                .news-weight {
                    float: right;
                    font-size: 10px;
                    letter-spacing: 0;
                    line-height: 18px;
                }
            }
        }
        .good-mask {
            position: absolute;
            width: 98%;
            height: 300px;
            background-color: rgba(0, 0, 0, 0.5);
            transition: all 0.2s;
            justify-content: center;
            display: flex;
            align-items: center;
            flex-direction: column;
            opacity: 0;
            cursor: pointer;
            span {
                transition: all 1s;
                border: 1px solid #fff;
                color: #fff;
                border-radius: 20px;
                display: flex;
                justify-content: center;
                align-items: center;
                flex-direction: row;
                width: 140px;
                height: 40px;
                box-sizing: border-box;
                a {
                    text-decoration: none;
                    color: #fff;
                }
                &:first-child {
                    margin-bottom: 10px;
                }
                &:hover {
                    background-color: rgb(246, 79, 111);
                    border: 1px solid $bcolor;
                }
            }
        }
        &:last-child {
            margin-right: 0;
        }
        &:hover {
            border: 1px solid $bcolor;
            .good-mask {
                opacity: 1;
            }
            .good-simple {
                img {
                    opacity: 0.7;
                }
                .news-title {
                    color: $bcolor;
                }
            }
        }
    }
}
</style>
